// https://dev.to/inimist/react-table-server-side-pagination-with-sorting-and-search-3163
import React, {forwardRef, useState, useEffect, useMemo, useRef} from "react"
import { useTable, usePagination, useSortBy } from "react-table"
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
// import axios from 'axios'

// import { USERS_COLUMNS } from "./columns"
// import SortIcon from 'mdi-react/SortIcon'
// import SortAscendingIcon from 'mdi-react/SortAscendingIcon'
// import SortDescendingIcon from 'mdi-react/SortDescendingIcon'
import ReactTablePagination from './ReactTablePagination'
import UsersFilter  from "./UsersFilter"

const SortIcon = () => <img src='/assets/sort.svg' alt="Sort" />;
const SortAscendingIcon = () => <img src='/assets/sort-ascending.svg' alt="Sort" />;
const SortDescendingIcon = () => <img src='/assets/sort-descending.svg' alt="Sort" />;

const queryClient = new QueryClient()

const initialState = {
    queryPageIndex: 0,
    queryPageSize: 10,
    totalCount: 0,
    queryPageFilter:"",
    queryPageSortBy: [],
};

const PAGE_CHANGED = 'PAGE_CHANGED';
const PAGE_SIZE_CHANGED = 'PAGE_SIZE_CHANGED';
const PAGE_SORT_CHANGED = 'PAGE_SORT_CHANGED';
const PAGE_FILTER_CHANGED = 'PAGE_FILTER_CHANGED';
const TOTAL_COUNT_CHANGED = 'TOTAL_COUNT_CHANGED';

export const USERS_COLUMNS = [
    {
        Header: "Email",
        accessor: "email",
    },
    {
        Header: "Name",
        accessor: "name",
    },
    {
        Header: "Phone",
        accessor: "phone",
    },
    {
        Header: "Role",
        accessor: "role",
    },
    {
        Header: "Employee Number",
        accessor: "employee_number"
    },
]


const reducer = (state, { type, payload }) => {
  switch (type) {
    case PAGE_CHANGED:
        return {
            ...state,
            queryPageIndex: payload,
        };
    case PAGE_SIZE_CHANGED:
        return {
            ...state,
            queryPageSize: payload,
        };
    case PAGE_SORT_CHANGED:
        return {
            ...state,
            queryPageSortBy: payload,
        };
    case PAGE_FILTER_CHANGED:
        return {
            ...state,
            queryPageFilter: payload,
        };
    case TOTAL_COUNT_CHANGED:
        return {
            ...state,
            totalCount: payload,
        };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
};

const fetchUsersData = async (page, pageSize, pageFilter, pageSortBy) => {
    // /users?page=${page+1}&limit=${pageSize}${paramStr}
    // let paramStr = ''
    // if( pageFilter.trim().length > 1 ) {
    //     paramStr = `&keyword=${pageFilter}`
    // }
    // if( pageSortBy.length > 0 ) {
    //     const sortParams = pageSortBy[0];
    //     const sortyByDir = sortParams.desc ? 'desc' : 'asc'
    //     paramStr = `${paramStr}&sortby=${sortParams.id}&direction=${sortyByDir}`
    // }
    try {
        // const response = await axios.get(
        // `/users?page=${page+1}&limit=${pageSize}${paramStr}`
        // );
        // const results = response.data.data;
        // const data = {
        //     results: results,
        //     count: response.data.total
        // };
        
        const results = [
            {
                "email": "faraz@xaprio.com",
                "name": "Faraz",
                "phone": "8448255414",
                "role": "Developer",
                "employee_number": "EMP/1903",
            },
            {
                "email": "faraz@xaprio.com",
                "name": "Faraz",
                "phone": "8448255414",
                "role": "Developer",
                "employee_number": "EMP/1903",
            },
            {
                "email": "faraz@xaprio.com",
                "name": "Faraz",
                "phone": "8448255414",
                "role": "Developer",
                "employee_number": "EMP/1903",
            },
            {
                "email": "faraz@xaprio.com",
                "name": "Faraz",
                "phone": "8448255414",
                "role": "Developer",
                "employee_number": "EMP/1903",
            },
            {
                "email": "faraz@xaprio.com",
                "name": "Faraz",
                "phone": "8448255414",
                "role": "Developer",
                "employee_number": "EMP/1903",
            },
        ];
        const data = {
            results: results,
            count: 5
        };
        return data;
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
};

const DataTable = () => {
    const [keyword, setKeyword] = useState('');
    const [useFilter, setUseFilter] = useState(false);
    const onClickFilterCallback = ( filter ) => {
        if(filter.trim() === "") {
            alert('Please enter a keyword to search!')
            return
        }
        if(filter === keyword)   {
            alert('No change in search')
            return
        }
        setUseFilter(true)
        setKeyword(filter)
    }

    let columns = useMemo( () => USERS_COLUMNS, [])

    const [{ queryPageIndex, queryPageSize, totalCount, queryPageFilter, queryPageSortBy }, dispatch] =
    React.useReducer(reducer, initialState);

    const { isLoading, error, data, isSuccess } = useQuery(
        ['users', queryPageIndex, queryPageSize, queryPageFilter, queryPageSortBy],
        () => fetchUsersData(queryPageIndex, queryPageSize, queryPageFilter, queryPageSortBy),
        {
            keepPreviousData: false,
            staleTime: Infinity,
        }
    );

    const totalPageCount = Math.ceil(totalCount / queryPageSize)

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        getToggleHideAllColumnsProps,
        allColumns,
        page,
        pageCount,
        pageOptions,
        gotoPage,
        previousPage,
        canPreviousPage,
        nextPage,
        canNextPage,
        setPageSize,
        state: { pageIndex, pageSize, sortBy }
    } = useTable({
        columns,
        data: data?.results || [],
        initialState: {
            pageIndex: queryPageIndex,
            pageSize: queryPageSize,
            sortBy: queryPageSortBy,
        },
        manualPagination: true,
        pageCount: data ? totalPageCount : null,
        autoResetSortBy: false,
        autoResetExpanded: false,
        autoResetPage: false
    },
    useSortBy,
    usePagination,
    );

    const Checkbox = forwardRef(({ intermediate, ...rest }, ref) => {
        const defaulRef = useRef();
        const resolvdRef = ref || defaulRef;
    
        useEffect(() => {
          resolvdRef.current.intermediate = intermediate;
        }, [resolvdRef, intermediate])
    
        return (
          <>
            <input type="checkbox" ref={resolvdRef} {...rest} />
          </>
        )
    });

    const [colvis, setColvis] = useState(false);
    const refColvis = useRef(null);
    useEffect(() => {
        function handleClickOutside(event) {
        if (refColvis.current && !refColvis.current.contains(event.target)) {
            setColvis(false);
        }
        }
        document.addEventListener("mousedown", handleClickOutside);
    }, [refColvis]);

    const handleColvis = (e) => {
        if (colvis) {
        setColvis(false)
        } else {
        setColvis(true)
        }
    }

    function tableToCSV() {
        var csv_data = [];
        var rows = document.getElementsByTagName('tr');
        for (var i = 0; i < rows.length; i++) {
          var cols = rows[i].querySelectorAll('td,th');
          var csvrow = [];
          for (var j = 0; j < cols.length; j++) {
            csvrow.push(cols[j].innerText);
          }
          csv_data.push(csvrow.join(","));
        }
        csv_data = csv_data.join('\n');
        downloadCSVFile(csv_data);
    }
    
    function downloadCSVFile(csv_data) {
        var CSVFile = new Blob([csv_data], {
          type: "text/csv"
        });
        var temp_link = document.createElement('a');
        temp_link.download = "data.csv";
        var url = window.URL.createObjectURL(CSVFile);
        temp_link.href = url;
        temp_link.style.display = "none";
        document.body.appendChild(temp_link);
        temp_link.click();
        document.body.removeChild(temp_link);
    }

    const manualPageSize = []
    
    useEffect(() => {
        dispatch({ type: PAGE_CHANGED, payload: pageIndex });
    }, [pageIndex]);

    useEffect(() => {
        dispatch({ type: PAGE_SIZE_CHANGED, payload: pageSize });
        gotoPage(0);
    }, [pageSize, gotoPage]);

    useEffect(() => {
        dispatch({ type: PAGE_SORT_CHANGED, payload: sortBy });
        gotoPage(0);
    }, [sortBy, gotoPage]);

    useEffect(() => {
        if ( useFilter ) {
            dispatch({ type: PAGE_FILTER_CHANGED, payload: keyword });
            gotoPage(0);
        }
    }, [keyword, gotoPage, useFilter]);

    React.useEffect(() => {
        if (data?.count) {
            dispatch({
            type: TOTAL_COUNT_CHANGED,
            payload: data.count,
            });
        }
    }, [data?.count]);

    if (error) {
        return <p>Error</p>;
    }

    if (isLoading) {
        return <p>Loading...</p>;
    }
    if(isSuccess)
    return (
            <>
                <div className='table react-table'>
                    <form className="form form--horizontal">
                        <div className="form__form-group">
                            <div className="col-md-9 col-lg-9">
                                <UsersFilter onClickFilterCallback={onClickFilterCallback} defaultKeyword={keyword} />
                            </div>
                            {/* <div className="col-md-3 col-lg-3 text-right pr-0">
                                <Link style={{maxWidth:'200px'}}
                                className="btn btn-primary account__btn account__btn--small"
                                to="/users/add"
                                >Add new user
                                </Link>
                            </div> */}
                        </div>
                    </form>
                    {
                        typeof data?.count === 'undefined' && <p>No results found</p>
                    }
                    {data?.count && 
                    <>
                    <div className='col-md-6'>
                        <div className='d-flex justify-content-end'>
                            <div className='colvis_content'>
                                <div className='position-relative' ref={refColvis} onClick={e => handleColvis(e)}>
                                    <button type="button" id="colvis" className="colvis">column</button>
                                    <div className="dropdown-menu" style={{ display: (colvis) ? 'block' : 'none' }}>
                                        <Checkbox {...getToggleHideAllColumnsProps()} /> Toggle All
                                        {
                                            allColumns.map(column => (
                                                <div key={column.id}>
                                                    <label>
                                                        <input type="checkbox" {...column.getToggleHiddenProps()} />
                                                        {column.Header}
                                                    </label>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='export_btn'>
                                <button type="button" onClick={tableToCSV}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M9.82451 1.84121H5.38984C4.00318 1.83587 2.86718 2.94054 2.83384 4.32721V11.4852C2.80384 12.8865 3.91584 14.0465 5.31651 14.0765C5.34118 14.0765 5.36584 14.0772 5.38984 14.0765H10.7152C12.1085 14.0272 13.2098 12.8792 13.2018 11.4852V5.35854L9.82451 1.84121Z" stroke="#1D8F83" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M9.6499 1.8334V3.77274C9.6499 4.7194 10.4159 5.48674 11.3626 5.4894H13.1986" stroke="#1D8F83" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M7.76131 10.6332V6.60588" stroke="#1D8F83" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M6.19751 9.06294L7.76084 10.6329L9.32418 9.06294" stroke="#1D8F83" strokeLinecap="round" strokeLinejoin="round" />
                                </svg> Export</button>
                            </div>
                        </div>
                    </div>
                    <table {...getTableProps()} className="table">
                        <thead>
                            {headerGroups.map( (headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map( column => (
                                        <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                            {column.render('Header')}
                                            {column.isSorted ? <Sorting column={column} /> : ''}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody className="table table--bordered" {...getTableBodyProps()}>
                            {page.map( row => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()}>
                                        {
                                            row.cells.map( cell => {
                                                return <td {...cell.getCellProps()}><span>{cell.render('Cell')}</span></td>
                                            })
                                        }
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    </>
                }
                </div>
                {(rows.length > 0) && (
                    <>
                        <ReactTablePagination
                            page={page}
                            gotoPage={gotoPage}
                            previousPage={previousPage}
                            nextPage={nextPage}
                            canPreviousPage={canPreviousPage}
                            canNextPage={canNextPage}
                            pageOptions={pageOptions}
                            pageSize={pageSize}
                            pageIndex={pageIndex}
                            pageCount={pageCount}
                            setPageSize={setPageSize}
                            manualPageSize={manualPageSize}
                            dataLength={totalCount}
                        />
                        <div className="pagination justify-content-end mt-2">
                            <span>
                            Go to page:{' '}
                            <input
                                type="number"
                                value={pageIndex + 1}
                                onChange={(e) => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                gotoPage(page);
                                }}
                                style={{ width: '100px' }}
                            />
                            </span>{' '}
                            <select
                            value={pageSize}
                            onChange={(e) => {
                                setPageSize(Number(e.target.value));
                            }}
                            >
                            {[10, 20, 30, 40, 50].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                                </option>
                            ))}
                            </select>
                        </div>
                    </>
                )}
            </>
    )
}

const Sorting = ({ column }) => (
    <span className="react-table__column-header sortable">
      {column.isSortedDesc === undefined ? (
        <SortIcon />
      ) : (
        <span>
          {column.isSortedDesc
            ? <SortAscendingIcon />
            : <SortDescendingIcon />}
        </span>
      )}
    </span>
  );

const TableWrapper = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <DataTable />
        </QueryClientProvider>
    )
}

export default TableWrapper;